import { FC } from 'react';
import { SvgIcon } from '@/components';
import { UPDATE_STATUS } from '../index';
import { statusMap } from '../const';
import { WidgetInfo } from '@/shared';
/** https://xiaomi.f.mioffice.cn/docs/dock4Hcp1p4eT1bVwtEgiP2KQQf# */
interface UpdateImplButtonProps {
  onClick?: (formDisable: boolean) => void;
  item: WidgetInfo;
}
const UpdateImplButton: FC<UpdateImplButtonProps> = ({
  onClick = () => {},
  item,
}) => {
  const updateStatusClassName =
    statusMap.get(item.status as number) || '';
  /** 容错-防止后台返回的状态码为null或者不是约定的状态码时 */
  if (!updateStatusClassName) return null;
  /**
     *  [0, 'unready'], //(0, "草稿")
        [10, 'ready'], //(10, "已填写")
        [7, 'under-review'], //(7,"审核平台审核中"),
        [12, 'under-review'], //(12,"应用商店审核中"),
        [1, 'published'], //(1, "上架"),
        [8, 'unpass'], //(8,"驳回审核"),
        [11, 'tokeoff'], //(11, "运营下线"),
        [STORE_OFFLINE_CODE, 'offline'], //(2, "商店下线")
     */
  const m = new Map([
    [
      'unready',
      { buttonName: window.trans('update-information'), formDisable: false },
    ],
    ['ready', { buttonName: '资料待提交', formDisable: false }],
    ['under-review', { buttonName: '资料审核中', formDisable: true }],
    [
      'published',
      { buttonName: window.trans('update-information'), formDisable: false },
    ],
    ['unpass', { buttonName: '更新失败', formDisable: false }],
    ['tokeoff', { buttonName: '更新失败', formDisable: false }],
    ['offline', { buttonName: '更新失败', formDisable: false }],
  ]);
  return (
    <div
      className="opt-btn cursor update-widget-impl-button"
      style={{ marginRight: '14px' }}
      onClick={() => {
        onClick(m.get(updateStatusClassName)?.formDisable || false);
      }}
    >
      <span>{m.get(updateStatusClassName)?.buttonName}</span>
      <SvgIcon
        style={{
          marginLeft: '7px',
        }}
        className="arrow-right"
        name={'arrow-down'}
        width="12"
        height="6"
      />
    </div>
  );
};
export default UpdateImplButton;
